/* NDC recenzii (07.10) – fișier propriu numeredecasa.ro.
 * 1) Lightbox pentru pozele clienților (toate paginile cu recenzii).
 * 2) Pe /pages/recenzii: filtre (nota, cu poze, produs), sortare, numărători.
 * 3) Loguri de debug cu prefixul [NDC-REC] (vezi consola browserului).
 * Datele vin din atributele data-* puse de Liquid (snippets/ndc-rec-card.liquid).
 */
(function () {
  'use strict';
  if (window.__ndcRecInit) { console.log('[NDC-REC] script deja încărcat – ignor a doua încărcare'); return; }
  window.__ndcRecInit = true;

  function log() {
    try { console.log.apply(console, ['[NDC-REC]'].concat([].slice.call(arguments))); } catch (e) { /* fără consolă */ }
  }

  /* ---------- 0. ce s-a afișat (debug) ---------- */
  function logSectiuni() {
    document.querySelectorAll('[data-ndc-rec-sectiune]').forEach(function (s) {
      log('secțiune', s.dataset.ndcRecSectiune, {
        numar: s.dataset.numar, afisate: s.dataset.afisate, prag: s.dataset.prag, produs: s.dataset.produs,
        carduri: s.querySelectorAll('[data-ndc-rec-card]').length
      });
    });
    var asc = document.querySelector('[data-ndc-rec-ascunse]');
    if (asc) log('pagina: recenzii afișate ' + asc.dataset.ndcRecAfisate + ', ascunse (nota 1–2, regula 3–5): ' + asc.dataset.ndcRecAscunse);
    var sub3 = [].slice.call(document.querySelectorAll('[data-ndc-rec-card]')).filter(function (c) { return Number(c.dataset.nota) < 3; });
    if (sub3.length) log('ATENȚIE: ' + sub3.length + ' card(uri) cu nota sub 3 afișate – NU ar trebui', sub3.map(function (c) { return c.id; }));
    else log('regula 3–5: niciun card cu nota sub 3 în pagină ✔');
    var r = document.querySelector('[data-ndc-rec-rating]');
    if (r) log('rating sub titlu', { medie: r.dataset.medie, numar: r.dataset.numar });
    else log('rating sub titlu: nu e afișat (0 note la produs sau nu e pagină de produs)');
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        if (j['@type'] === 'Product') log('JSON-LD Product', { aggregateRating: j.aggregateRating || null, review: (j.review || []).length });
      } catch (e) { log('JSON-LD invalid', e.message); }
    });
  }

  /* ---------- 1. lightbox ---------- */
  function initLightbox() {
    var lb = document.querySelector('[data-ndc-rec-lb]');
    if (!lb) { log('lightbox: lipsește <dialog> – pozele nu se pot mări'); return; }
    var img = lb.querySelector('[data-ndc-rec-lb-img]');
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ndc-rec-foto]');
      if (b) {
        img.src = b.dataset.ndcRecFoto;
        img.alt = b.dataset.alt || '';
        log('lightbox deschis', b.dataset.ndcRecFoto);
        if (typeof lb.showModal === 'function') lb.showModal(); else window.open(b.dataset.ndcRecFoto, '_blank');
        return;
      }
      if (e.target.closest('[data-ndc-rec-lb-close]') || e.target === lb) {
        lb.close();
        log('lightbox închis');
      }
    });
    lb.addEventListener('close', function () { img.src = ''; });
  }

  /* ---------- 2. filtre + sortare pe /pages/recenzii ---------- */
  function initLista() {
    var lista = document.querySelector('[data-ndc-rec-lista]');
    if (!lista) return;
    var grid = lista.querySelector('[data-ndc-rec-grid]');
    var carduri = [].slice.call(grid.querySelectorAll('[data-ndc-rec-card]'));
    var selProdus = lista.querySelector('[data-ndc-rec-produs]');
    var selSort = lista.querySelector('[data-ndc-rec-sort]');
    var gol = lista.querySelector('[data-ndc-rec-niciuna]');
    var stare = { f: 'toate', produs: '', sort: 'noi' };
    log('listă: ' + carduri.length + ' recenzii publicate în pagină (Liquid: ' + lista.dataset.publicate + ')');

    // produsele din recenzii → opțiunile din listă
    var produse = {};
    carduri.forEach(function (c) { if (c.dataset.produs) produse[c.dataset.produs] = c.dataset.produsTitlu || c.dataset.produs; });
    Object.keys(produse).sort(function (a, b) { return produse[a].localeCompare(produse[b], 'ro'); }).forEach(function (h) {
      var o = document.createElement('option'); o.value = h; o.textContent = produse[h]; selProdus.appendChild(o);
    });
    log('produse cu recenzii:', Object.keys(produse));

    function trece(c, f) {
      if (stare.produs && c.dataset.produs !== stare.produs) return false;
      if (f === 'toate') return true;
      if (f === 'poze') return Number(c.dataset.poze) > 0;
      return c.dataset.nota === f;
    }

    function numara() {
      lista.querySelectorAll('[data-ndc-rec-f]').forEach(function (b) {
        var n = carduri.filter(function (c) { return trece(c, b.dataset.ndcRecF); }).length;
        b.querySelector('[data-c]').textContent = '(' + n + ')';
        b.disabled = n === 0 && b.dataset.ndcRecF !== 'toate';
      });
    }

    function aplica(motiv) {
      var vizibile = 0;
      carduri.forEach(function (c) { var ok = trece(c, stare.f); c.hidden = !ok; if (ok) vizibile++; });
      var ord = carduri.slice().sort(function (a, b) {
        var da = Number(a.dataset.data), db = Number(b.dataset.data), na = Number(a.dataset.nota), nb = Number(b.dataset.nota);
        if (stare.sort === 'mare') return nb - na || db - da;
        if (stare.sort === 'mica') return na - nb || db - da;
        return db - da || (a.id < b.id ? 1 : -1);
      });
      ord.forEach(function (c) { grid.appendChild(c); });
      gol.hidden = vizibile > 0;
      numara();
      log('aplic (' + motiv + ')', JSON.stringify(stare), '→ vizibile ' + vizibile + '/' + carduri.length);
    }

    lista.querySelectorAll('[data-ndc-rec-f]').forEach(function (b) {
      b.addEventListener('click', function () {
        stare.f = b.dataset.ndcRecF;
        lista.querySelectorAll('[data-ndc-rec-f]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        aplica('filtru');
      });
    });
    selProdus.addEventListener('change', function () { stare.produs = selProdus.value; aplica('produs'); });
    selSort.addEventListener('change', function () { stare.sort = selSort.value; aplica('sortare'); });

    // link direct la o recenzie (#rec-r0001): o lăsăm vizibilă
    aplica('pornire');
    if (location.hash && location.hash.indexOf('#rec-') === 0) {
      var t = document.querySelector(location.hash);
      if (t) { t.hidden = false; t.scrollIntoView({ block: 'center' }); log('recenzie din link', location.hash); }
    }
  }

  function start() {
    try { logSectiuni(); } catch (e) { log('eroare logSectiuni', e); }
    try { initLightbox(); } catch (e) { log('eroare lightbox', e); }
    try { initLista(); } catch (e) { log('eroare listă', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
